import React from 'react';
import ReactDom from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { BrowserRouter } from "react-router-dom";
import TsIndex from './TsIndex.jsx';

const render = Component => {
	ReactDom.render(
		<AppContainer>
			<BrowserRouter>
				<Component />
			</BrowserRouter>
		</AppContainer>,
		document.getElementById('TsIndex')
	)
}

render(TsIndex)

if (module.hot) {
	module.hot.accept('./TsIndex.jsx', () => { render(TsIndex) })
}


// WEBPACK FOOTER //
// ./src/js/index.jsx